import React, { createContext, useContext, useState, ReactNode } from 'react';
import { AgentThread } from '@dreamai/types';

interface SidebarDrawerContextType {
  openDrawer: string | null;
  setOpenDrawer: (drawer: string | null) => void;
  drawerThreads: AgentThread[];
  setDrawerThreads: (threads: AgentThread[]) => void;
}

const SidebarDrawerContext = createContext<
  SidebarDrawerContextType | undefined
>(undefined);

export const SidebarDrawerProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [openDrawer, setOpenDrawer] = useState<string | null>(null);
  const [drawerThreads, setDrawerThreads] = useState<AgentThread[]>([]);

  return (
    <SidebarDrawerContext.Provider
      value={{ openDrawer, setOpenDrawer, drawerThreads, setDrawerThreads }}
    >
      {children}
    </SidebarDrawerContext.Provider>
  );
};

export const useSidebarDrawer = () => {
  const context = useContext(SidebarDrawerContext);
  if (!context) {
    throw new Error(
      'useSidebarDrawer must be used within a SidebarDrawerProvider',
    );
  }
  return context;
};
